import React from 'react'

import { Card, CardContent } from '@mui/material'

import { useSticky } from '../../../hooks/useSticky'
import './FloatingToolbar.scss'

type FloatingToolbarProps = {
  children: React.ReactNode
}

export const FloatingToolbar: React.FC<FloatingToolbarProps> = ({ children }) => {
  const { ref, isSticky } = useSticky<HTMLDivElement>({ threshold: [1], rootMargin: '-1px 0px' })
  const elevation = isSticky ? 10 : 1

  return (
    <Card ref={ref} className="FloatingToolbar" elevation={elevation}>
      <CardContent>{children}</CardContent>
    </Card>
  )
}

export default FloatingToolbar
